export default "<div class=\"navbar-nav nav-link mr-5\">\r\n    <small>Currently logged as: {{ RoleName }}</small>\r\n</div>\r\n"